<template>
  <div class="panel-body">
    <import-data :route="'plano-modulo'" :json_fields="headers" :json_data="planosModulo"></import-data>
    <div class="row">
      <div class="col-md-12">
        <filterable @loading="changeLoading" ref="filter" v-bind="filterable">
          <thead slot="thead">
            <tr>
              <th>{{$t('words.options')}}</th>
              <th>Nome</th>
              <th>Descrição</th>
              <th>Valor</th>
            </tr>
          </thead>
          <tr slot-scope="{item, dropup}">
            <td class="column-options">
              <div class="btn-group" :class="{'dropup': dropup}">
                <button type="button" class="btn btn-default btn-sm dropdown-toggle"
                  v-bind:title="$t('words.operations')" data-toggle="dropdown" aria-haspopup="true"
                  aria-expanded="false">
                  <i class="fa fa-bars" aria-hidden="true"></i>
                  <span class="caret"></span>
                </button>
                <div class="dropdown-menu">
                    <a class="dropdown-item" @click="detailsObject(item)">
                      <i class="fa fa-eye"></i>
                      {{$t('words.details') }}
                    </a>                 
                    <router-link class="dropdown-item" :to="{ name: `planoModuloEdit`, params: { id: item.id}}">
                      <i class="fa fa-pencil"></i>
                      {{$t('words.edit')}}
                    </router-link>
                    <a class="dropdown-item" @click="deleteData(item.id, item.nome, 'plano-modulo')">
                      <i class="fa fa-trash" aria-hidden="true"></i>
                      {{$t('words.delete')}}
                    </a>                
                </div>
              </div>
            </td>
            <td>{{item.nome}}</td>
            <td>{{item.descricao}}</td>
            <td>{{formatMoney(item.valor)}}</td>
          </tr>
        </filterable>
      </div>
    </div>
    <show-data :description="description" :data="objectDetails" :headers="headers"></show-data>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        filterable: {
          deleted: false,
          model: 'planoModulo',
          options: 'municipios',
          storeAction: 'setPlanoModulo',
          storeName: 'planoModulo.data',
          url: '/api/planos-modulo',
          loading: false,
        },
        objectDetails: {},
        description: 'nome',
        headers: {
          'Modulo': 'nome',
          'Descrição': 'descricao',
        }
      };
    },
    computed: {
      planosModulo() {
        return this.$store.state.planoModulo.data;
      }
    },
    watch: {
      $route(data) {
        if (data.name === 'planosModulo') {
          this.prepareComponent();
        }
      }
    }
  };
</script>